const CURRENCY_FIELDS = new Set(['market_cap', 'free_cash_flow']);
const SHARE_FIELDS = new Set(['average_volume']);

const compactNumber = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 2,
});

const regularNumber = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 4,
});

export const evidenceRuleLabel = (rule) => {
  if (rule?.field === 'beta') {
    if (['>=', '>'].includes(rule.operator)) return 'Minimum Beta';
    if (['<=', '<'].includes(rule.operator)) return 'Maximum Beta';
  }
  return String(rule?.field || 'rule')
    .replaceAll('_', ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());
};

export const formatEvidenceValue = (field, value) => {
  if (value === null || value === undefined) return 'Unavailable';
  if (Array.isArray(value)) return value.map((item) => formatEvidenceValue(field, item)).join(', ');
  if (typeof value === 'boolean') return String(value);
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return String(value);
  if (CURRENCY_FIELDS.has(field)) return `$${compactNumber.format(numeric)}`;
  if (SHARE_FIELDS.has(field)) return `${compactNumber.format(numeric)} shares`;
  return regularNumber.format(numeric);
};

export const exactEvidenceValue = (value) => (
  Array.isArray(value) ? value.join(', ') : String(value)
);
